import React from 'react';
import { Typography } from '@mui/material';
import { SettingsSection } from 'src/pages/ProjectSettingsPage/components/SettingsSection';
import { ProfileImageUpload } from 'src/pages/ProfileSettingsPage/components/ProfileImageUpload';
import { LogoIcon } from 'src/icons/LogoIcon';
import { ProfileImageType } from 'src/model/api/v2/data-contracts';
import { ts } from 'src/utils/translate';
import { theme } from 'src/theme/mui-theme';

type Props = {
    logoFileName: string;
};

export const LogoSection = ({ logoFileName }: Props) => {
    return (
        <SettingsSection
            title={ts('profile_settings_logo', 'Logo')}
            titleIcon={<LogoIcon />}
            titleAction={
                <Typography component="span" variant="body2" color={theme.palette.text.secondary}>
                    {ts('profile_settings_logo_caption', 'Logo, cover header and cover footer')}
                </Typography>
            }
        >
            <ProfileImageUpload type={ProfileImageType.Logo} fileName={logoFileName} />
        </SettingsSection>
    );
};
